

import React, { useEffect } from 'react'
import Event from './eventImg/event-19-dec.webp'


const Event23 = () => {
    useEffect(() => {
        document.title = "A half day program on Direct Carbon Capture at Negative Cost (DCCNC)";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>19 December 2025</h1>
        <h3 className='text-center'>A half day program on Direct Carbon Capture at Negative Cost (DCCNC)</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='A half day program on Direct Carbon Capture at Negative Cost (DCCNC)'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/pluscn8rjf3O8k=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event23




